import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { __ } from '@wordpress/i18n';
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { RadioGroup as ReakitRadioGroup, useRadioState } from 'reakit';
import { View } from '../View';
import { RadioGroupContext } from './RadioGroup.Context';

function RadioGroup(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'RadioGroup'),
      baseId = _useContextSystem.baseId,
      children = _useContextSystem.children,
      id = _useContextSystem.id,
      _useContextSystem$lab = _useContextSystem.label,
      label = _useContextSystem$lab === void 0 ? __('RadioGroup') : _useContextSystem$lab,
      value = _useContextSystem.value,
      otherProps = _objectWithoutProperties(_useContextSystem, ["baseId", "children", "id", "label", "value"]);

  var radio = useRadioState({
    baseId: baseId || id,
    state: value
  });
  var contextProps = React.useMemo(function () {
    return {
      radio: radio
    };
  }, [radio]);
  return /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: contextProps
  }, /*#__PURE__*/React.createElement(ReakitRadioGroup, Object.assign({
    "aria-label": label,
    as: View,
    ref: forwardedRef
  }, otherProps), children));
}

export default contextConnect(RadioGroup, 'RadioGroup');